var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("verify-phone-component", {
        attrs: {
          submitVerificationCode: _vm.oobaChallenge,
          cancelLink: "forcechallenge/cancel",
          logoutLink: "forcechallenge/logout",
          resendLink: "authentication/sendverificationcodechallenge"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ddaa3b2", { render: render, staticRenderFns: staticRenderFns })
  }
}